import { makeStyles } from "@material-ui/core/styles";
// import { Colors } from "../../theme/colors";

const useStyles = makeStyles(() => ({
  checkboxWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    width: "100%",
    marginTop: "15px",
  },
}));

export default useStyles;
